import { render } from "./register.vue?vue&type=template&id=1c68cdc2&scoped=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"

import "./register.vue?vue&type=style&index=0&id=1c68cdc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c68cdc2"

export default script